<div class="col-xs-12"> 

      <div class="col-xs-12" >
<div class="box no-padding">
  <div class="box-header">
      <h3 class="box-title">Listagem</h3>
      <div class="box-tools">
          <form autocomplete="off">
              <div class="input-group input-group-sm" style="width: 150px;">
                  <input type="text" name="table_search" class="form-control pull-right" placeholder="Pesquisar" >
                  <div class="input-group-btn">
                      <button type="submit" class="btn btn-default">
                          <i class="fa fa-search"></i>
                      </button>
                  </div>
              </div>
                      <div class="form-group col-sm-12 no-padding" style="margin-top: 8px;">
                <label class="checkbox-inline">
                    <input type="checkbox" [(ngModel)]="manterFiltrosSelecionados" name="manterFiltrosSelecionados"
                        (ngModelChange)="alterarManterFiltrosSelecionados($event)">
                    Manter filtros selecionados
                </label>
            </div></form>
      </div>
  </div>

  <div class="box-body table-responsive no-padding">
      <table class="table table-striped">
          <tbody>
              <tr>
                  <th>Pendências</th>
                  <th>Descrição</th>
                  <th class="text-center">Ações</th>
              </tr>
              <tr >
                  <td>Dinheiro</td>
                  <td>Escassez</td>
                  <td class="text-center">
                      <span class="badge bg-gray cursor" pTooltip="Visualizar" tooltipPosition="top" 
                         > <i class="fa fa-fw fa-eye"></i> </span>
            
                    
                      
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
</div>
</div>
